module.exports = __webpack_public_path__ + "static/media/NV.aaaa1573.jpg";